export const validatePixKey = (key, type) => {
  switch (type) {
    case 'phone':
      return /^(\+55)?(\d{2})(\d{4,5})(\d{4})$/.test(key.replace(/\D/g, ''))
    case 'email':
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(key)
    case 'cpf':
      return /^\d{11}$/.test(key.replace(/\D/g, ''))
    case 'CPF':
      return /^\d{11}$/.test(key.replace(/\D/g, ''))
    case 'evp':
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(key)
    case 'random':
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(key)
    default:
      return false
  }
}

export const pixKeyTypeMapper = {
  phone: 'Telefone',
  email: 'e-mail',
  cpf: 'CPF',
  CPF: 'CPF',
  evp: 'Chave aleatória',
  random: 'Chave aleatória'
}
